import { FormattedMessage } from "@mnemonic/intl";

import { validateEmptyField } from "../Pages/Login/utils/validate";
import { TextField } from "./MuiFinalForm";

export const UsernameTextField = ({ autoFocus, name }: { name: string; autoFocus: boolean }) => {
  return (
    <TextField
      name={name}
      autoComplete="username"
      autoFocus={autoFocus}
      fullWidth
      label={<FormattedMessage id="Username" defaultMessage="Username" />}
      validate={(value: string) => validateEmptyField(value)}
    />
  );
};
